export interface Coloumn {
  no:number,
  invoiceNo: string;
  invoiceDate: string;
  paymentType: string;
  netAmount: string;
  vehicleNumber: string;
  name: string;
  serviceType: string;
}
export interface CardData {
  id: string;
  cardType: string;
  cardNumber: string;
  cardHolderName: string;
  expiryDate: string ;
}

export const paymentsHeader:any = [
  {name:'No',sortData:"no",sortIcon:false},
  {name:'Invoice No',sortData:'invoiceNumber',sortIcon:true},
  {name:'Invoice Date',sortData:'createdAt',sortIcon:true},
  {name:'Payment Type',sortData:'method',sortIcon:false},
  {name:'Net Amount (VAT Included)',sortData:'netAmount',sortIcon:false},
  {name:'Vehicle Number',sortData:'vehicleNumber',sortIcon:false},
  {name:'Name',sortData:'name',sortIcon:false},
  {name:'Service Type',sortData:'service',sortIcon:true},
  {name:'Action',sortIcon:false}
]
export const tableHeading=[{

  no: "No",
  invoiceNo: "Invoice No",
  invoiceDate:"Invoice Date",
  paymentType: "Payment Type",
  netAmount: "Net Amount (VAT Included)",
  vehicleNumber: "Vehicle Number",
  serviceType: "Service Type",
}]
export const paymentsData: Array<Coloumn> = [
  {
    no:1,
    invoiceNo: "JH876HG8876",
    invoiceDate: "7/5/2022",
    paymentType: "Credit Card",
    netAmount: "£ 20.00",
    vehicleNumber: "JH76 JHU",
    name: "Thomas Criss1",
    serviceType: "Car Parking1",
  },
  {
    no:2,
    invoiceNo: "JH876HG8877",
    invoiceDate: "7/28/2022",
    paymentType: "Debit Card",
    netAmount: "£ 20.00",
    vehicleNumber: "JH77 JHU",
    name: "Thomas Criss2",
    serviceType: "Car Parking2",
  },
  {
    no:3,
    invoiceNo: "AH876HG8878",
    invoiceDate: "01/10/2021",
    paymentType: "Wallet",
    netAmount: "£ 20.00",
    vehicleNumber: "AH78 JHU",
    name: "Thomas Criss3",
    serviceType: "Car Parking3",

  },
  {
    no:4,
    invoiceNo: "bH876HG8879",
    invoiceDate: "01/10/2021",
    paymentType: "Apple Pay",
    netAmount: "£ 20.00",
    vehicleNumber: "BH79 JHU",
    name: "Thomas Criss4",
    serviceType: "Car Parking4",
  },
  {
    no:5,
    invoiceNo: "JH876HG8880",
    invoiceDate: "01/10/2021",
    paymentType: "Google Pay",
    netAmount: "£ 20.00",
    vehicleNumber: "JH80 JHU",
    name: "Thomas Criss5",
    serviceType: "Car Parking5",
  },
  {
    no:6,
    invoiceNo: "JH876HG8881",
    invoiceDate: "05/10/2021",
    paymentType: "Google Pay",
    netAmount: "£ 50.00",
    vehicleNumber: "JH80 JHU",
    name: "Thomas Criss6",
    serviceType: "Car Parking6",
  },
  {
    no:7,
    invoiceNo: "JH876HG8882",
    invoiceDate: "05/10/2021",
    paymentType: "Google Pay",
    netAmount: "£ 80.00",
    vehicleNumber: "JH80 JHU",
    name: "Thomas Criss6",
    serviceType: "Car Parking7",
   },
];
export interface CardData {
  id: string;
  cardType: string;
  cardNumber: string;
  cardHolderName: string;
  expiryDate: string ;
}
// card data
export const cardsDummyData: Array<CardData> = [
  {
    id: "fh5252f",
    cardType: "Debit",
    cardNumber: "*** *** *** *** 2871",
    cardHolderName: "Jason",
    expiryDate: "10/23",
  }
]
// Filter Interfaces 
export interface filterInterFace {
  timeFrame: string,
  vehicleNumber: string,
  serviceType:string
}
export interface filterStateInterFace {
  timeFrame: string,
  vehicleNumber: string,
  serviceType:string
  startDate?: any,
  endDate?: any,
}
//Time frame filter data
export const filtertimeframe = [
  { time: "Today" },
  { time: "Last Week" },
  { time: "This Month" },
  { time: "Last Month" },
  { time: "Year To Date" },
  { time: "Last Year" },
  { time: "Date Range" },
];
// Vehicle Numbers filter data
export const vehiclenumberfilter = [
  { vehicle: "ABC 1234567" },
  { vehicle: "ppcn123" },
  { vehicle: "lkaa"},
  { vehicle: "ppcn123"},
];
// Service Type filter data
export const serviceType = [
  { service: "pcn"},
  { service: "parking"},
  
];

export const pdfDetails = {
  invoiceNo :' INV01230925',
  totalAmount:"£20.00",
  descPCNNo:'PCN-876343232',
  descDate:'07/07/2021 - 01/01/2022',
  headerContact:["647-44-1234","info@drivertok.co.uk","drivertok.co.uk"],
  headerAddress:["Suite 6 Office I-K, 6-9","The Square, Stockley","Park,Uxbridge, England,","UB11 1FW"],
  billedTo:["Jayden Smith","Jayed.S@gmail.com","4 Roundwood Avenue","#82 Hayes, Uxbridge,","UB11 1AF Uk"],
  invoiceDetails:[{name:"INVO123654977",color:'',fw:''},{name:'Date Of Issue',color:'',fw:'bold'},{name:"10/07/22",color:'#6E7191',fw:''},{name:"Payment Date",color:'',fw:'bold'},{name:"19/07/22",color:'#6E7191',fw:''}],

}

export const pdfTableHeading=[{
  no: "No",
  invoiceNo: "Invoice No",
  invoiceDate:"Invoice Date",
  paymentType: "Payment Type",
  netAmount: "Net Amount (VAT included)",
  vehicleNumber: "Vehicle Number",
  name: "Name",
  serviceType: "Service Type",
  }]


